export enum PresenceTemplateRepeatPatternEnum {
  NEVER = 'never',
  WEEKLY = 'weekly',
  EVERY_2_WEEKS = 'every_2_weeks',
}
